<template>
  <signup :title="promotionDetails.title"
          :sub-title="'למימוש הטבה והרשמה לשירות:'"
          :button-title="'הרשמה'"
          :button-action="generateCodeAndProceed"
          :error="serverErrors.generateCode"
          :reset-error="() => resetError('generateCode')">
    <template v-slot:header>
      <img class="promotion-header" :src="require(`@/assets/${promotionDetails.header}`)"/>
    </template>
    <template v-slot:information-details>
      <information-details :title="promotionDetails.detailsTitle"
                           :details="promotionDetails.details"/>
    </template>
  </signup>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import Signup from '@/base-components/Signup';
import InformationDetails
  from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/InformationDetails';
import GenerateCodeMixin from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/GenerateCodeMixin';
import Segment from '../../../../../../Segment';
import promotionConsts from '../../../../../../constants/promotions';

export default {
  name: 'IntroductionWithPercentageDiscountPromo',
  mixins: [GenerateCodeMixin],
  components: {
    InformationDetails,
    Signup,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('RegistrationEntered', { promotion: this.promotion });
    Segment.trackUserGotToPixel('RE');
  },
  computed: {
    ...mapState('signup', ['phoneNumber', 'firstName', 'lastName', 'serverErrors', 'email', 'enableMarketingEmails']),
    ...mapState('promotions', ['promotion', 'benefitAmount', 'benefitPercentage']),
    promotionDetails() {
      return promotionConsts.getPercentageDiscountPromotionDetails(this.promotion, this.benefitAmount, this.benefitPercentage);
    },
  },
  methods: {
    ...mapMutations('signup', ['resetError']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.generateCodeForSignup(firstName, lastName, phoneNumber, email, enableMarketingEmails);
      this.next();
    },
    goToLogin() {
      window.location.href = '/sr';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';
.promotion-header {
  width: 100%;
}

</style>
